import { useState, type FormEvent } from 'react';
import { api, ApiError } from '@/lib/api';
import { Modal } from '@/components/ui/Modal';
import { Button } from '@/components/ui/Button';
import { Input } from '@/components/ui/Input';

export function EvaluacionModal({
  open, proveedorID, onClose, onCreated,
}: {
  open: boolean;
  proveedorID: string;
  onClose: () => void;
  onCreated: () => void;
}) {
  const year = new Date().getFullYear();
  const [periodo, setPeriodo] = useState(`${year}-Q${Math.ceil((new Date().getMonth() + 1) / 3)}`);
  const [calidad, setCalidad] = useState('');
  const [tiempo, setTiempo] = useState('');
  const [servicio, setServicio] = useState('');
  const [precio, setPrecio] = useState('');
  const [comentarios, setComentarios] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  const num = (s: string) => (s === '' ? undefined : parseInt(s, 10));

  async function submit(e: FormEvent) {
    e.preventDefault();
    setSubmitting(true);
    setErr(null);
    try {
      await api(`/proveedores/${proveedorID}/evaluaciones`, {
        method: 'POST',
        body: {
          periodo,
          calificacion_calidad: num(calidad),
          calificacion_tiempo: num(tiempo),
          calificacion_servicio: num(servicio),
          calificacion_precio: num(precio),
          comentarios,
        },
      });
      onCreated();
    } catch (e) {
      setErr(e instanceof ApiError ? e.message : 'Error');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Registrar evaluación de desempeño"
      subtitle="Escala 1-10. Se calcula el promedio automáticamente."
      footer={
        <>
          <Button variant="ghost" type="button" onClick={onClose}>Cancelar</Button>
          <Button type="submit" form="eval-form" loading={submitting}>Guardar evaluación</Button>
        </>
      }
    >
      <form id="eval-form" onSubmit={submit} className="flex flex-col gap-4">
        {err && <div className="rounded-md bg-rose-50 px-3 py-2 text-[13px] text-rose-700">{err}</div>}

        <Input name="periodo" label="Periodo" required placeholder="2026-Q1, 2026-ANUAL"
               value={periodo} onChange={(e) => setPeriodo(e.target.value)} />

        <div className="grid grid-cols-2 gap-4 sm:grid-cols-4">
          <Input name="calidad" label="Calidad (1-10)" type="number" min={1} max={10}
                 value={calidad} onChange={(e) => setCalidad(e.target.value)} />
          <Input name="tiempo" label="Tiempo" type="number" min={1} max={10}
                 value={tiempo} onChange={(e) => setTiempo(e.target.value)} />
          <Input name="servicio" label="Servicio" type="number" min={1} max={10}
                 value={servicio} onChange={(e) => setServicio(e.target.value)} />
          <Input name="precio" label="Precio" type="number" min={1} max={10}
                 value={precio} onChange={(e) => setPrecio(e.target.value)} />
        </div>

        <div>
          <label className="text-[13px] font-medium text-ink">Comentarios</label>
          <textarea
            value={comentarios}
            onChange={(e) => setComentarios(e.target.value)}
            rows={3}
            className="mt-1.5 w-full rounded-md border border-border bg-surface px-3 py-2 text-[14px] shadow-subtle focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-500/20"
          />
        </div>
      </form>
    </Modal>
  );
}
